/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Create_TitleInputs */

const en_settings_apikeys_create_title = /** @type {(inputs: Settings_Apikeys_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create API Key`)
};

/**
* | output |
* | --- |
* | "Create API Key" |
*
* @param {Settings_Apikeys_Create_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_create_title = /** @type {((inputs?: Settings_Apikeys_Create_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Create_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_create_title(inputs)
});
export { settings_apikeys_create_title as "settings.apikeys.create_title" }